import i18next from 'i18next';
import { parse } from 'date-fns';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { convertUTCToLocal } from 'utils/date';
import ChevronRightIcon from 'components/atoms/icons/chevron-right';

import s from './styles.module.scss';

import type { Nullable } from 'infrastructure/types';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';
import type { BaseLog } from 'infrastructure/classes/logs/base-log';

const checkValue = (value?: Nullable<string>) =>
  !value || value === 'null' ? i18next.t('labels.bannerNoData') : value;

export const logsColumns = (): IBaseTableColumns<BaseLog> => {
  return [
    {
      label: i18next.t('labels.dateTime'),
      key: 'date',
      width: '170px',
      render(value) {
        const date = parse(value, 'MM-dd-yyyy | hh:mm a', new Date());
        const localDate = convertUTCToLocal(date.toString());
        let formattedDate;

        if (localDate) {
          formattedDate = DateFormatter({
            date: localDate,
            format: DateFormats['MM/dd/yyyy, h:mm a'],
          });
        }

        return <span className={s.date}>{formattedDate}</span>;
      },
    },
    {
      label: i18next.t('labels.statusChanging'),
      key: 'from',
      width: '400px',
      responsive: ['md'],
      render(_, record) {
        return (
          <div data-cy="logs-status-change">
            {record.from && (
              <>
                <span className={s.from} data-cy="logs-status-change-from">
                  {`${i18next.t('labels.from')}: ${checkValue(record.from)} `}
                </span>
                <ChevronRightIcon />
              </>
            )}
            <span className={s.to} data-cy="logs-status-change-to">
              {` ${i18next.t('labels.to')}: ${checkValue(record.to)}`}
            </span>
          </div>
        );
      },
    },
    {
      label: i18next.t('labels.electronicallySigned'),
      align: 'left',
      key: 'who',
      width: '330px',
      render(value) {
        return (
          <span className={s.who} data-cy="logs-electronicallySigned">
            {value}
          </span>
        );
      },
    },
  ];
};
